import {
  getEmailConfig,
  updateEmailConfig,
  testEmailConnection,
} from '../../shared/services/apiService';

// ── Load current email configuration ─────────────────────────────────────────
export const loadEmailConfig = async () => {
  const res = await getEmailConfig();
  return res.data.data.config || null;
};

// ── Persist email configuration changes ──────────────────────────────────────
export const saveEmailConfig = async (configData) => {
  await updateEmailConfig(configData);
};

// ── Test SMTP connection with current settings ────────────────────────────────
export const testSmtpConnection = async (configData) => {
  await testEmailConnection(configData);
};

// ── Extract template variables from subject + body ────────────────────────────
export const detectEmailVars = (subject, body) => {
  const src    = (subject || '') + ' ' + (body || '');
  const found  = [...new Set(src.match(/\{\{[a-zA-Z0-9_]+\}\}/g) || [])];
  const KNOWN  = {
    '{{fullName}}': { desc: "Recipient's full name",         example: 'John Doe' },
    '{{username}}': { desc: 'Auto-generated login username', example: 'johndoe_4821' },
    '{{password}}': { desc: 'Auto-generated login password', example: 'Xk7#mP2q' },
    '{{appUrl}}':   { desc: 'Frontend application URL',      example: 'https://yourapp.com' },
  };
  return found.map(tag => ({ tag, ...(KNOWN[tag] || { desc: 'Custom variable', example: tag }) }));
};
